import { render, staticRenderFns } from "./MainTop.vue?vue&type=template&id=6dfa24c6&scoped=true&"
import script from "./MainTop.vue?vue&type=script&lang=js&"
export * from "./MainTop.vue?vue&type=script&lang=js&"
import style0 from "./MainTop.vue?vue&type=style&index=0&id=6dfa24c6&lang=scss&scoped=true&"
import style1 from "./MainTop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa24c6",
  null
  
)

export default component.exports